<template>
  <div class="about-management">
    <div class="toolbar">
      <el-button type="primary" @click="showAddDialog">添加项目</el-button>
    </div>

    <el-table :data="displayItems" border v-loading="loading">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="section_type" label="类型">
        <template #default="{ row }">
          {{ getSectionTypeName(row.section_type) }}
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" />
      <el-table-column prop="is_active" label="启用" width="100">
        <template #default="{ row }">
          <el-switch
            v-model="row.is_active"
            @change="toggleStatus(row)"
            active-text="启用"
            inactive-text=""
          />
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="创建时间" width="180">
        <template #default="{ row }">
          {{ formatDate(row.created_at) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template #default="{ row }">
          <el-button size="small" @click="editItem(row)">编辑</el-button>
          <el-button size="small" type="danger" @click="deleteItem(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      v-if="total > 0"
      :current-page="currentPage"
      :page-sizes="[20, 50, 100, { value: -1, label: '全部' }]"
      :page-size="pageSize"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handlePageChange"
      class="pagination"
    />

    <el-dialog v-model="dialogVisible" :title="dialogTitle" width="900px">
      <el-form :model="form" label-width="100px">
        <el-form-item label="类型" v-if="!currentId">
          <el-select v-model="form.section_type" :disabled="!!currentId">
            <el-option
              v-for="type in sectionTypes"
              :key="type.value"
              :label="type.label"
              :value="type.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="标题">
          <el-input v-model="form.title" />
        </el-form-item>
        <el-form-item label="内容">
          <el-input v-model="form.content" type="textarea" :rows="20" />
        </el-form-item>
        <el-form-item label="启用">
          <el-switch
            v-model="form.is_active"
            active-text="启用"
            inactive-text=""
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveItem">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import api from '../../api'

export default {
  name: 'AboutManagement',
  data() {
    return {
      items: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      loading: false,
      dialogVisible: false,
      dialogTitle: '编辑',
      form: {
        section_type: '',
        title: '',
        content: '',
        is_active: true
      },
      currentId: null,
      sectionTypes: [
        { value: 'opensource', label: '开源项目地址' },
        { value: 'author', label: '作者留言' }
      ]
    }
  },
  computed: {
    displayItems() {
      return this.items
    }
  },
  mounted() {
    this.loadItems()
  },
  methods: {
    async loadItems() {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          page_size: this.pageSize === -1 ? 'all' : this.pageSize
        }
        
        const response = await api.get('/admin/about/sections/', { params })
        
        if (Array.isArray(response.data)) {
          this.items = response.data
          this.total = response.data.length
        } else {
          this.items = response.data.results || []
          this.total = response.data.count || 0
        }
      } catch (error) {
        this.$message.error('加载失败')
        this.items = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    showAddDialog() {
      this.dialogTitle = '添加项目'
      this.currentId = null
      this.form = {
        section_type: '',
        title: '',
        content: '',
        is_active: true
      }
      this.dialogVisible = true
    },
    editItem(item) {
      this.dialogTitle = `编辑${this.getSectionTypeName(item.section_type)}`
      this.currentId = item.id
      this.form = {
        section_type: item.section_type,
        title: item.title,
        content: item.content,
        is_active: item.is_active !== undefined ? item.is_active : true
      }
      this.dialogVisible = true
    },
    async deleteItem(item) {
      try {
        await this.$confirm(`确定要删除"${this.getSectionTypeName(item.section_type)}"吗？`, '提示', {
          type: 'warning'
        })
        await api.delete(`/admin/about/sections/${item.id}/`)
        this.$message.success('删除成功')
        this.loadItems()
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('删除失败')
        }
      }
    },
    async saveItem() {
      try {
        if (!this.form.section_type && !this.currentId) {
          this.$message.warning('请选择类型')
          return
        }
        if (!this.form.title) {
          this.$message.warning('请输入标题')
          return
        }
        
        if (this.currentId) {
          await api.patch(`/admin/about/sections/${this.currentId}/`, this.form)
          this.$message.success('更新成功')
        } else {
          await api.post('/admin/about/sections/', this.form)
          this.$message.success('添加成功')
        }
        this.dialogVisible = false
        this.loadItems()
      } catch (error) {
        console.error('保存失败:', error)
        this.$message.error('保存失败: ' + (error.response?.data?.detail || error.message))
      }
    },
    getSectionTypeName(type) {
      const map = {
        opensource: '开源项目地址',
        author: '作者留言'
      }
      return map[type] || type
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.loadItems()
    },
    handlePageChange(page) {
      this.currentPage = page
      if (this.pageSize !== -1) {
        this.loadItems()
      }
    },
    async toggleStatus(item) {
      try {
        await api.patch(`/admin/about/sections/${item.id}/`, {
          is_active: item.is_active
        })
        this.$message.success(item.is_active ? '已启用' : '已禁用')
      } catch (error) {
        // 恢复原状态
        item.is_active = !item.is_active
        this.$message.error('状态更新失败')
        console.error(error)
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return '-'
      const date = new Date(dateStr)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    }
  }
}
</script>

<style scoped>
.about-management {
  width: 100%;
}

.toolbar {
  margin-bottom: 20px;
}

.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
</style>

